import { InjectionToken } from "@angular/core";
import { AppConfig } from "./app-config/config.types";
import {IGoogleAnalyticsSettings} from "@hakimio/ngx-google-analytics";

export const APP_CONFIGURATION = new InjectionToken<AppConfig>("APP_CONFIGURATION");

export const NGX_GOOGLE_ANALYTICS_SETTINGS_TOKEN = new InjectionToken<IGoogleAnalyticsSettings>("NGX_GOOGLE_ANALYTICS_SETTINGS_TOKEN");
